import L from 'leaflet';

function padNumber(number, digits) {
	return ('0'.repeat(digits) + number).slice(-digits);
}

function calculatePercentage(start, stop, current) {
	return Math.ceil(Math.min((current - start) / (stop - start) * 100, 100));
}

L.control.timeSlider = function (options, widget) {
	return new L.Control.TimeSlider(options, widget);
};

L.Control.TimeSlider = L.Control.extend({
	options: {
		position: 'bottomright',
		format: timestamp => {
			let date = new Date(timestamp);

			return [
				date.getDate() + '.' + (date.getMonth() + 1) + '.',
				padNumber(date.getHours(), 2) + ':' + padNumber(date.getMinutes(), 2)
			].join(' ');
		},
	},

	initialize: function (options, widget) {
		L.Util.setOptions(this, options);

		this.widget = widget;
	},

	onAdd: function (map) {
		let container = L.DomUtil.create('div', 'widget-control-timeslider');
		L.DomEvent.disableClickPropagation(container);
		L.DomEvent.disableScrollPropagation(container);

		let percentage_current = calculatePercentage(
			this.widget.time.options.startTime,
			this.widget.time.options.stopTime,
			this.widget.time.options.currentTime
		);

		let percentage_now = calculatePercentage(
			this.widget.time.options.startTime,
			this.widget.time.options.stopTime,
			this.widget.time._nowTime
		);

		this._track = L.DomUtil.create('div', 'timeslider-track', container);
		this._track.setAttribute('touch-action', 'none');
		L.DomEvent.on(this._track, 'pointerdown touchstart mousedown', this._onPointerDown, this);
		L.DomEvent.on(this._track, 'pointercancel touchcancel', this._onPointerUp, this);

		this._past = L.DomUtil.create('div', 'timeslider-past', this._track);
		this._past.style.width = percentage_now + '%';

		this._future = L.DomUtil.create('div', 'timeslider-future', this._track);
		this._future.style.width = 100 - percentage_now + '%';

		this._current = L.DomUtil.create('div', 'timeslider-current', this._track);
		this._current.style.width = percentage_current + '%';

		this._tooltip = L.DomUtil.create('div', 'timeslider-tooltip', this._track);
		this._tooltip.style.left = percentage_current + '%';
		this._tooltip.innerHTML = this.options.format(this.widget.time.options.currentTime);

		this.widget.time.on('TIME_PLAYBACK_TICKED TIME_PLAYBACK_SEEKED', this._update, this);
		this.widget.time.on('TIME_NOW_UPDATED', this._update, this);

		setTimeout(this._update.bind(this), 0);

		return container;
	},

	onRemove: function (map) {
		this.widget.time.off('TIME_PLAYBACK_TICKED TIME_PLAYBACK_SEEKED', this._update, this);
		this.widget.time.off('TIME_NOW_UPDATED', this._update, this);

		L.DomEvent.off(this._track);
	},

	_update: function () {
		let percentage_current = calculatePercentage(
			this.widget.time.options.startTime,
			this.widget.time.options.stopTime,
			this.widget.time.options.currentTime
		);

		this._current.style.width = percentage_current + '%';
		this._tooltip.style.left = percentage_current + '%';

		this._tooltip.innerHTML = this.options.format(this.widget.time.options.currentTime);

		let percentage_now = calculatePercentage(
			this.widget.time.options.startTime,
			this.widget.time.options.stopTime,
			this.widget.time._nowTime
		);

		this._past.style.width = percentage_now + '%';
		this._future.style.width = 100 - percentage_now + '%';
	},

	_getTimestampFromEvent(event) {
		// REVIEW This is a workaround for touch devices that don't have clientX
		//        and clientY on the TouchEvent itself.
		if (isNaN(event.clientX)) {
			if (event.touches instanceof TouchList && event.touches.length > 0) {
				let touch = event.touches.item(0);
				event.clientX = touch.clientX;
				event.clientY = touch.clientY;
			} else {
				return this.widget.time.options.startTime;
			}
		}

		let x = L.DomEvent.getMousePosition(event, this._track).x;

		let percentage = calculatePercentage(0, this._track.offsetWidth, x) / 100;

		let diff = this.widget.time.options.stopTime - this.widget.time.options.startTime;

		let timestamp = this.widget.time.options.startTime + (diff * percentage);

		return timestamp;
	},

	_onPointerDown: function (event) {
		L.DomEvent.preventDefault(event);
		L.DomEvent.stopPropagation(event);

		let timestamp = this._getTimestampFromEvent(event);
		this.widget.time.setTime(timestamp);

		L.DomEvent.on(document, 'pointermove touchmove mousemove', this._onPointerMove, this);
		L.DomEvent.on(document, 'pointerup touchend mouseup', this._onPointerUp, this);
	},

	_onPointerMove: function (event) {
		L.DomEvent.preventDefault(event);
		L.DomEvent.stopPropagation(event);

		let timestamp = this._getTimestampFromEvent(event);

		if (timestamp <= this.widget.time.options.stopTime) {
			this.widget.time.setTime(timestamp);
		}
	},

	_onPointerUp: function (event) {
		L.DomEvent.off(document, 'pointermove touchmove mousemove', this._onPointerMove, this);
		L.DomEvent.off(document, 'pointerup touchend mouseup', this._onPointerUp, this);
	},
});
